import React from "react";
import UserImg from "../assets/OLA-IMG.jpg";
import backgroundImg from "../assets/imgaeBackground.png";
import arrowImg from "../assets/arrow.webp";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin,
  faCodepen,
  faHashnode,
  faGoogleDrive,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";

export default function Index() {
  return (
    <div
      style={{
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        minHeight: "100vh",
      }}
    >
      <div className="p-8 py-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:mt-32">
          <div className="bg-gradient-to-r from-orange-200 via-pink-300 to-red-400 p-4 md:col-span-2 rounded-md">
            <h1 className="text-5xl mt-2 font-bold animate__animated animate__fadeInBottomLeft">
              Hello, I'm Olamiji Badmos.
            </h1>
            <h3 className="py-8 leading-9 text-xl font-medium aniamate__animated animate__bounceIn">
              As a front-end developer, I specialize in crafting user-friendly
              digital experiences. <br />
              Beyond coding, I share my passion for technology through technical
              writing, contributing valuable insights to the developer
              community. Currently, I'm exploring the realm of developer
              advocacy to further share my passion for technology and connect
              with like-minded enthusiasts.
            </h3>

            <div className="grid grid-cols-4 gap-2 animate__animated animate__flipInX">
              <a
                href="https://drive.google.com/file/d/1S2Zyy4YajsaYGWTeFJK-wXM4UyKkUMMB/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                className="relative rounded-lg bg-pink-300 hover:bg-pink-200 flex justify-center items-center h-12 text-lg font-semibold flex-col md:flex-row md:items-center group"
              >
                <FontAwesomeIcon
                  icon={faGoogleDrive}
                  className="mr-2 md:mr-2 md:mb-0"
                />
                <span className="hidden md:block">Resume</span>
                <span className="absolute bottom-full mb-2 px-2 py-1 bg-black text-white text-xs rounded hidden group-hover:block md:hidden">
                  Resume
                </span>
              </a>
              <Link
                to="/projects"
                className="relative rounded-lg bg-pink-200 hover:bg-pink-400 flex justify-center items-center h-12 text-lg font-semibold flex-col md:flex-row md:items-center group"
              >
                <FontAwesomeIcon
                  icon={faCodepen}
                  className="mr-2 md:mr-2 md:mb-0"
                />
                <span className="hidden md:block">Projects</span>
                <span className="absolute bottom-full mb-2 px-2 py-1 bg-black text-white text-xs rounded hidden group-hover:block md:hidden">
                  Projects
                </span>
              </Link>
              <a
                href="https://www.linkedin.com/in/olamijibadmos/"
                target="_blank"
                rel="noopener noreferrer"
                className="relative rounded-lg bg-pink-400 hover:bg-pink-300 flex justify-center items-center h-12 text-lg font-semibold flex-col md:flex-row md:items-center group"
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  className="mr-2 md:mr-2 md:mb-0"
                />
                <span className="hidden md:block">LinkedIn</span>
                <span className="absolute bottom-full mb-2 px-2 py-1 bg-black text-white text-xs rounded hidden group-hover:block md:hidden">
                  LinkedIn
                </span>
              </a>
              <a
                href="https://olamijibadmos.hashnode.dev/"
                target="_blank"
                rel="noopener noreferrer"
                className="relative rounded-lg bg-pink-200 hover:bg-pink-400 flex justify-center items-center h-12 text-lg font-semibold flex-col md:flex-row md:items-center group"
              >
                <FontAwesomeIcon
                  icon={faHashnode}
                  className="mr-2 md:mr-2 md:mb-0"
                />
                <span className="hidden md:block">Articles</span>
                <span className="absolute bottom-full mb-2 px-2 py-1 bg-black text-white text-xs rounded hidden group-hover:block md:hidden">
                  Articles
                </span>
              </a>
            </div>
          </div>
          <div
            className="flex justify-center items-center"
            class="animate__animated animate__fadeInTopRight"
          >
            <img
              src={UserImg}
              alt="portfolio-img"
              className="rounded-full w-full md:w-auto h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
